import type { FunctionComponent } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as _ from 'lodash';
import * as ReportGenerationStore from '../../../../../redux/reportGeneration';
import type { ReportGenerationParams } from '../../shared/types';
import projectGroupSelectors, { getSelectedReleaseId } from '../../../../../redux/project_grouping/selectors';
import Loader from '../../../../generic/Loader';
import { Provider } from './ReportContainerContext';
import { DefaultDependencyInfoOptions } from '../utils';

type Props = {
  params: ReportGenerationParams;
};

const ProjectGroupReportContainer: FunctionComponent<Props> = ({ params, children }) => {
  const dispatch = useDispatch();

  const groupId = parseInt(params.projectGroupId || '', 10);
  const releaseId: number | undefined = useSelector(getSelectedReleaseId);
  const currentProjectGroup = useSelector((state) => projectGroupSelectors.getCurrentProjectGroup(state, { params }));

  useEffect(() => {
    if (currentProjectGroup) {
      dispatch(ReportGenerationStore.actions.setCustomHeaderText(currentProjectGroup.reportCustomText));
    }
    if (groupId && releaseId) {
      dispatch(ReportGenerationStore.actions.setProjectGroupContext({ groupId, releaseId }));
    }
  }, [dispatch, groupId, releaseId, currentProjectGroup]);

  if (!groupId && !releaseId) {
    return <Loader />;
  }

  return (
    <Provider value={{ dependencyInfoOptions: DefaultDependencyInfoOptions, setDependencyInfoOptions: _.noop }}>
      {children}
    </Provider>
  );
};

export default ProjectGroupReportContainer;
